module.exports = __webpack_public_path__ + "img/Logo_Header_White.85173596.svg";